import * as yup from 'yup';

export const sexSchema = yup.object({
    name: yup.string().label('name').required('Este campo es requerido'),
});

export type sexSchemaType = yup.InferType<typeof sexSchema>
